import React from 'react'
import Tag from './Tag';


const getTagColor = (text) => {
    switch (text) {
      case "red":  
        return "red";
      case "blue":  
        return "blue";
      case "green":  
        return "green";  
      default:
        return "gray"; // fallback color for any other text
    }
  };

function GenericTagComp({text,color,onChipClick,tagIcon}) {
  if (!text) {
    return null;
  }
  return (
    <div onClick={onChipClick}>  <Tag key={text+color+"gtc"} text={<>{tagIcon} {text}</>} color={getTagColor(color)}  /></div>
  
  )
}

export default GenericTagComp


